import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-table-profile',
    templateUrl: './table-component.html',
    styleUrls: ['./table-component.scss']
})

export class TableComponent implements OnInit {
    @Input() tableKeys : Array<any>;
    @Input() data_array : Array<any>;
    @Input() type : string = "";
    @Output() emitAction = new EventEmitter<string>();

    constructor() {
    	
    }

    ngOnInit() {}

    callAction(actionName){
        this.emitAction.emit(actionName);
    }
}
